import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  InputBase,
  Avatar,
  Drawer,
  Badge,
  Menu,
  MenuItem,
  FormControl,
  Select,
  Tooltip,
} from "@mui/material";
import { AiOutlineLogout, AiOutlineUser } from "react-icons/ai";
import { MdAssignment, MdAssessment } from "react-icons/md";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { useLocation } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import { FaUserCog } from "react-icons/fa";
import { IoDocumentText } from "react-icons/io5";
import { IoIosNotificationsOutline } from "react-icons/io";
import { MdOutlineAccessTime } from "react-icons/md";
import { CgMenuGridO } from "react-icons/cg";
import DarkModeToggle from "../Theme/DarkModeToggle.js";
import { useNavigate } from "react-router-dom";
import { fetchAllEntities, filterEntities, logoutUser,} from "../apis/apiService.js";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogActions,DialogContent, DialogContentText, DialogTitle, Button,} from "@mui/material";
import Breadcrumbs from "./common/Breadcrumbs.js";
import {
  useFetchIssueModuleQuery,
  useFetchMilestoneModuleQuery,
  useFetchNotificationListQuery,
  useFetchTimesheetModuleQuery,
  useFetchUserInfoQuery,
} from "../slice/logdetailSlice.js";
import { format } from "date-fns";
import { postNotification } from "../apis/apiService.js";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setloginUserName } from "../selectSlice.js";
import { CommonAddLogHours } from "./common/CommonAddLogHour.js";
import { Offcanvas, OffcanvasBody } from "react-bootstrap";
import { CommonAddTaskTab } from "./common/Task/CommonAddTaskTab.js";
import { CommonAddIssue } from "./common/Issue/CommonAddIssue.js";
import { AddProjectComponent } from "../pages/projects/Project.js";
import { AddMilestoneComponent } from "../pages/milestones/Milestone.js";
import HeaderCirclePlusMultiComponents from "./common/HeaderCirclePlus/HeaderCirclePlusMultiComponents.jsx";
import CRMImageDark from "../assets/images/Header/crm2.png";
// import { Offcanvas, OffcanvasBody } from "react-bootstrap";
import { AddLeave } from "../pages/crm/AddLeave.js";
import { useTheme } from "../ThemeContext.js";
import CRMImageLight from "../assets/images/Header/crm3.png";
import { openInNewTab } from "../utils/openInNewTab";

const SearchContainer = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  padding: "0 8px",
  display: "flex",
  alignItems: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  marginLeft: theme.spacing(1),
}));

function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showMinipOPuP, setShowMiniPopUp] = useState(false);
  const [drawerTimer, setDrawerTimerOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showTimelog, setShowTimelog] = useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [timerDetails, setTimerDetails] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [timerType, setTimerType] = useState("myTimer");
  const [showComponentNames, setShowComponentNames] = useState("timelog");
  // const [showTaskComponent, setShowTaskComponent] = useState(false);
  const { data: notification_list, refetch: notification_refetch } =
    useFetchNotificationListQuery();
  const popupRef = useRef(null);

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user in task:", login_user);
  // const { role: login_user_role, id: login_user_id } = login_user;
  const { role: login_user_role } = login_user || {};
  const { refetch: issue_module_refetch } = useFetchIssueModuleQuery({
    view_type_id: 1,
    searchText: "",
  });
  const project_span = useSelector(
    (state) => state.selectOptions?.timesheetProjectSpan
  );
  const from_date = useSelector(
    (state) => state.selectOptions?.timesheetFromDate
  );
  const to_date = useSelector((state) => state.selectOptions?.timesheetToDate);

  const handleShowProject = () => {
    setShowTimelog((prev) => !prev);
  };
  const { data: user_list_info, refetch: user_list_info_refetch } =
    useFetchUserInfoQuery();

  const { refetch } =
    useFetchTimesheetModuleQuery({
      project_span: project_span,
      from_date: from_date,
      to_date: to_date,
      view_type: "all",
    });
  const { refetch: milestone_module_refetch, } = useFetchMilestoneModuleQuery({
    searchText: "",
    view_type_id: 1,
  });

  const fetchTaskModule = async () => {
    const requestedData = {
      view_type_id: 1,
    };
    try {
      await filterEntities("tasks/show/all", requestedData);
    } 
    catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };
  // const { data: total_log_hours, refetch: total_log_hours_refetch } =
  //   useFetchTotalLogHoursQuery({
  //     project_span: projectSpan,
  //     from_date: fromDate,
  //     to_date: toDate,
  //     view_type: filter,
  //   });
  // //console.log()("user_list_info:", user_list_info);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
    handleClose(); // Close the popover first
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const toggleDrawerTimer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerTimerOpen(open);
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  // const handleClose = () => {
  //   setOpen(false); // Close the dialog
  // user_list_info is auto-fetched by useFetchUserInfoQuery on mount
  const handleLogout = async () => {
    if (window._isLoggingOut) return;
    window._isLoggingOut = true;
    try {
      await logoutUser();
    } catch (error) {
      console.warn("Logout API notice:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      dispatch(setloginUserName(null));
      window._isLoggingOut = false;
      setOpen(false);
      setOpenDialog(false);
      window.location.href = "/login";
    }
  };

  // //console.log()("notification_id :", notification_id);
  const notificationCancel = async (notification_id) => {
    try {
      const response = await postNotification( "notification/view",notification_id);
      if (response) {
        notification_refetch?.();
      }
      // //console.log()("response:", response);
    } 
    catch (error) {
      console.error("Error during notification cancel:", error);
      // toast.error(
      //   error.message || "Failed to cancel notification. Please try again."
      // );
    }
  };

  const clearAllNotification = async () => {
    const response = await postNotification("notification", "markAllAsRead");
    if (response) {
      toast.success(response.message);
      notification_refetch();
      setDrawerOpen(false);
    }
  };

  const navigateTimer = (notification) => {
    const { project_id, task_id, issue_id, milestone_id, task_list_id } =
      notification;
    console.log("timer_path_id :", notification);
    if (project_id && task_id && milestone_id) {
      navigate(
        `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${milestone_id}/MilestoneSubTasklist/${task_list_id}/TasklistDetail/${task_id}`
      );
      setDrawerTimerOpen(false);
    }
     else if (project_id && issue_id) {
      navigate(
        `/projects/projectDetail/${project_id}/issue/IssueDetail/${issue_id}`
      );
      setDrawerTimerOpen(false);
    } 
    else if (project_id && task_id) {
      navigate(`/projects/projectDetail/${project_id}/taskdetail/${task_id}`);
      setDrawerTimerOpen(false);
    } 
    else if (project_id && issue_id && milestone_id) {
      navigate(
        `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${milestone_id}/MilestoneIssueDetail/${issue_id}`
      );
      setDrawerTimerOpen(false);
    }
  };

  const navigateNotification = (notification) => {
    const { project_id, task_id, issue_id, milestone_id, task_list_id, title } =
      notification;

    //  If no project ID, do not navigate
    if (!project_id) return;

    // Case 1: Task inside Milestone (with Task ID and Milestone ID)
    if (
      project_id &&
      task_id &&
      milestone_id &&
      task_list_id &&
      title === "Task"
    ) {
      navigate(
        `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${milestone_id}/MilestoneSubTasklist/${task_list_id}/TasklistDetail/${task_id}`
      );
      setDrawerOpen(false);

      // Case 2: Issue
    } 
    else if (project_id && issue_id) {
      navigate(`/projects/projectDetail/${project_id}/issue/IssueDetail/${issue_id}`);
      setDrawerOpen(false);
      // Case 3: Normal Task (without milestone)
    } 
    else if (project_id && task_id && title === "Task") {
      navigate(`/projects/projectDetail/${project_id}/taskdetail/${task_id}`);
      setDrawerOpen(false);
      // Case 4: Project-related notifications like Welcome, Invitation, Project
    }
    else if (
      project_id &&
      (title === "Welcome" || title === "Invitation" || title === "Project")
    ) {
      navigate(`/projects/projectDetail/${project_id}/details`);
      setDrawerOpen(false);
      // Case 5: Task List view
    }
     else if (project_id && title === "Task List") {
      navigate(`/projects/projectDetail/${project_id}/tasks`);
      setDrawerOpen(false);
      // Case 6: Milestone only
    }
    else if (project_id && milestone_id && title === "Milestone") {
      navigate(`/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${milestone_id}`);
      setDrawerOpen(false);
      // Case 7: Task List inside milestone
    } 
    else if (project_id && milestone_id && task_id && title === "Task List") {
      navigate(
        `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${milestone_id}/MilestoneSubTasklist/${task_list_id}`
      );
      setDrawerOpen(false);
    } 
    else {
      setDrawerOpen(false);
      return;
    }
  };
  const getTimerDetails = async (type = "myTimer") => {
    try {
      const response = await fetchAllEntities(`timer/getTimerDetails/${type}`);
      setTimerDetails(response.data);
      console.log("getTimerDetails :", response.data);
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    if (drawerTimer) getTimerDetails(timerType);
  }, [drawerTimer, timerType]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        showMinipOPuP
      ) {
        setShowMiniPopUp(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMinipOPuP]);

  const location = useLocation();
  // const currentRoute =
  //   location.pathname.split('/').pop().replace('-', ' ') || 'Dashboard';
  const title =
    location.state?.title ||
    location.pathname.split("/").pop().replace("-", " ") ||
    "Dashboard";
  const unreadCount = notification_list?.filter(
    (list) => list.is_read === 0
  ).length;
  const timerCount = timerDetails?.length;
  // //console.log()("countss: ", unreadCount);

  const CommonMenuShowPopup = (name) => {
    setShowMiniPopUp(!showMinipOPuP);
    const isStaging = window.location.hostname.includes("bacet.org") || window.location.hostname.includes("dev");

    if (name === "deals") {
      if (isStaging) {
        openInNewTab("https://dev2.technotackle.in/deals/web/site/login");
      } else {
        openInNewTab("https://deals.technotackle.in/");
      }
    }
    else if (name === "HRMS") {
      if (isStaging) {
        openInNewTab("https://devhrms.technotackle.in/web/site/login");
      } else {
        openInNewTab(process.env.REACT_APP_HRMS_WEB_URL || "https://hrms.technotackle.in/");
      }
    }
    else if (name === "incentive") {
      openInNewTab("https://incentive.technotackle.in/");
    } 
    else if (name === "assessment") {
      openInNewTab("http://Assessment.technotackle.in");
    } 
    else if (name === "CRM") {
      openInNewTab(process.env.REACT_APP_CRM_WEB_URL || "https://crm.technotackle.in");
    }
  };

  const CommonShowPopup = (name) => {
    if (name === "task") {
      // setShowTaskComponent(true);
      // setShowTimelogComponent(false);
      setShowComponentNames("task");
    } 
    else if (name === "timelog") {
      setShowComponentNames("timelog");
    } 
    else if (name === "issue") {
      setShowComponentNames("issue");
    } 
    else if (name === "project") {
      setShowComponentNames("project");
    } 
    else if (name === "milestone") {
      setShowComponentNames("milestone");
    }
  };

  const [showLeave, setShowLeave] = useState(false);
  const handleOpenLeave = () => setShowLeave(true);
  const handleCloseLeave = () => setShowLeave(false);
  
  const handleLeaveSubmitted = () => {
    // do refresh or toast here if needed
    setShowLeave(false);
  };
  const { isDarkMode } = useTheme();

  return (
    <AppBar position="static" color="transparent" className="bg-white mb-4">
      <Offcanvas
        show={showTimelog}
        placement="end"
        style={{ width: window.innerWidth > 768 ? "50%" : "85%" }}
      >
        <Offcanvas.Body className="p-0">
          <div>
            <div className="d-flex align-items-center gap-3">
              <div className=" m-3 ">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item pe-4" role="presentation">
                    <button
                      className=" active text-rgba-gray R_btn"
                      id="LogHours-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#LogHours"
                      type="button"
                      role="tab"
                      aria-controls="LogHours"
                      aria-selected="false"
                      onClick={() => CommonShowPopup("timelog")}
                    >
                      {/* {["ADMIN", "MANAGER"].includes(login_user_role) || // ✅ Always show for Admin & Manager
                          login_user_role === "CLIENT" ||
                          selectedUser === login_user_id ||
                          owner_name === login_user_name ? (
                            <div>Log Hours</div>
                          ) : null} */}
                      {/* {["ADMIN", "MANAGER"].includes(login_user_role) ||
                          login_user_role === "CLIENT" ||
                          selectedUser === login_user_id ||
                          isOwner ? ( */}
                      <div> Timelog</div>
                      {/* ) : null} */}
                    </button>
                  </li>

                  <li className="nav-item pe-4" role="presentation">
                    <button
                      className=" text-rgba-gray R_btn"
                      id="Subtasks-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Subtasks"
                      type="button"
                      role="tab"
                      aria-controls="Subtasks"
                      aria-selected="false"
                      onClick={() => CommonShowPopup("task")}
                    >
                      Task
                    </button>
                  </li>

                  {(login_user_role === "ADMIN" ||
                    login_user_role === " MANAGER") && (
                      <li className="nav-item pe-4" role="presentation">
                        <button
                          className=" text-rgba-gray R_btn"
                          id="Documents-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#Documents"
                          type="button"
                          role="tab"
                          aria-controls="Documents"
                          aria-selected="false"
                          onClick={() => CommonShowPopup("project")}
                        >
                          Project
                        </button>
                      </li>
                    )}

                  <li className="nav-item pe-4" role="presentation">
                    <button
                      className=" text-rgba-gray R_btn"
                      id="Issues-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Issues"
                      type="button"
                      role="tab"
                      aria-controls="Issues"
                      aria-selected="false"
                      onClick={() => CommonShowPopup("issue")}
                    >
                      Issue
                    </button>
                  </li>

                  <li className="nav-item pe-4" role="presentation">
                    <button
                      className=" text-rgba-gray R_btn"
                      id="ActivityStream-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#ActivityStream"
                      type="button"
                      role="tab"
                      aria-controls="ActivityStream"
                      aria-selected="false"
                      onClick={() => CommonShowPopup("milestone")}
                    >
                      Milestone
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            {showComponentNames === "task" && (
              <CommonAddTaskTab
                onCancel={handleShowProject}
                // ProjectID={ProjectID}
                refetchList={fetchTaskModule}
                path_1="task"
                path_2="add"
                isModule={true}
              />
            )}

            {showComponentNames === "timelog" && (
              <CommonAddLogHours
                onApply={handleShowProject}
                // onClear={() => reset()} // Resets to initial values
                onCancel={handleShowProject}
                span={project_span}
                fromDate={from_date}
                toDate={to_date}
                isModule={true}
                refetchList={refetch}
                onAddAnother={() => setShowTimelog(true)}
              />
            )}

            {showComponentNames === "issue" && (
              <CommonAddIssue
                // onClear={() => reset()} // Resets to initial values
                onCancel={handleShowProject}
                // Issues={Issues}
                fetchIssues={issue_module_refetch}
                path="issue"
                isModule={true}
              />
            )}

            {showComponentNames === "project" && (
              <AddProjectComponent
                // onClear={() => reset()}
                onCancel={handleShowProject}
              // onApply={handleAddProject}
              // fetchProjects={project_refetch}
              />
            )}

            {showComponentNames === "milestone" && (
              <AddMilestoneComponent
                // onApply={handleApplyFilter}
                // onClear={handleClearFilter}
                // onCancel={() => setShowFilter(false)}
                fetchMilestone={milestone_module_refetch}
                // onClear={() => reset()} // Resets to initial values
                onCancel={handleShowProject}
              />
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showLeave}
        placement="end"
        className="custom-offcanvas"
        style={{ width: window.innerWidth <= 768 ? "80%" : "50%" }}
      >
        <OffcanvasBody className="p-0">
          <AddLeave onCancel={handleCloseLeave} onSuccess={handleLeaveSubmitted} />
        </OffcanvasBody>
      </Offcanvas>
      
      <Toolbar className="p-0">
        <div className="container-fluid">
          <div className="row align-items-center w-100">
            {/* Route Title Section */}
            <div className="col-md-5">
              {/* <Typography variant='h6' component='div'> */}
              {/* {currentRoute.charAt(0).toUpperCase() + currentRoute.slice(1)} */}
              {/* {title.charAt(0).toUpperCase() + title.slice(1)} */}
              {/* </Typography> */}
              <Breadcrumbs />
            </div>

            {/* Search Bar Section */}

            <div className="col-md-7 d-flex align-items-center justify-content-end gap-3">
                <DarkModeToggle />
              {/* {login_user_role !== "CLIENT" && (
                <IconButton color="inherit" className=" ">
                
                  <CiCirclePlus
                    onClick={handleShowProject}
                    style={{ fontSize: "30px" }}
                  />
                </IconButton>
              )} */}
                <Tooltip title="Request Leave" arrow>
                  <IconButton
                    color="inherit"
                    onClick={handleOpenLeave}
                    sx={{
                      "& img": {
                        width: "22px",
                        height: "22px",
                        opacity: 0.6,
                        filter: isDarkMode ? "brightness(0) invert(1)" : "brightness(0)",
                        transition: "opacity 0.2s ease",
                      },
                      "&:hover": {
                        backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
                      },
                      "&:hover img": {
                        opacity: 1,
                      }
                    }}
                  >
                    <img
                      src={isDarkMode ? CRMImageLight : CRMImageDark}
                      alt="CRM"
                    />
                  </IconButton>
                </Tooltip>
                <HeaderCirclePlusMultiComponents />

                <Tooltip title="Notification" arrow>
                  <IconButton
                    color="inherit"
                    onClick={toggleDrawer(true)}
                    sx={{
                      color: isDarkMode ? "#a0a0a0" : "#707070",
                      "&:hover": {
                        color: isDarkMode ? "#ffffff" : "#000000",
                        backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
                      }
                    }}
                  >
                    <Badge badgeContent={unreadCount} color="error">
                      <IoIosNotificationsOutline
                        style={{ fontSize: "1.8rem" }}
                      />
                    </Badge>
                  </IconButton>
                </Tooltip>
                
                <Tooltip title="Timer" arrow>
                  <IconButton
                    color="inherit"
                    onClick={toggleDrawerTimer(true)}
                    sx={{
                      color: isDarkMode ? "#a0a0a0" : "#707070",
                      "&:hover": {
                        color: isDarkMode ? "#ffffff" : "#000000",
                        backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
                      }
                    }}
                  >
                    <Badge badgeContent={timerCount} color="error">
                      <MdOutlineAccessTime
                        style={{ fontSize: "1.8rem" }}
                      />
                    </Badge>
                  </IconButton>
                </Tooltip>

              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                transitionDuration={{ enter: 300, exit: 300 }}
                sx={{
                  "& .MuiDrawer-paper": {
                    width: "350px", // Adjusted width for better UX
                    padding: "16px",
                    backgroundColor: "var(--cell-bg-color)", // Light background
                  },
                }}
              >
                {/* Header with Close Button */}
                <div className="d-flex align-items-center justify-content-between">
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Notifications
                  </Typography>
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseIcon />
                  </IconButton>
                </div>
                {unreadCount > 0 && (
                  <p
                    className="text-end enterHourse"
                    onClick={clearAllNotification}
                  >
                    {/* clear all notification */}
                      Mark as all read
                  </p>
                )}
                {/* Notification Card */}

                {/* {notification_list?.map((notification, index) => (
                  <div
                    className={`p-3 mb-2 d-flex gap-3 align-items-start ${Number(notification.is_read) === 1
                      ? "notification-read"
                      : "notification-unread"
                      }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigateNotification(notification);
                      notificationCancel(notification.notification_id);
                    }}
                    key={index}
                  >
                    <Avatar alt="Profile" src={notification.image_url} />
                    <div>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#333",
                          fontSize: "1rem",
                          lineHeight: "1.4",
                        }}
                      >
                        {notification.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#333",
                          fontSize: "0.8rem",
                          lineHeight: "1.4",
                          textAlign: "justify",
                          // textIndent: 20,
                        }}
                      >
                        {notification.message}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#888",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        {notification.created_at
                          ? format(
                            new Date(notification.created_at),
                            "dd/MM/yyyy hh:mm a"
                          )
                          : "N/A"}
                      </Typography>
                    </div>
                  </div>
                ))} */}

                 {(!notification_list || notification_list.length === 0) ? (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#333",
                      fontSize: "0.8rem",
                      lineHeight: "1.4",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    No Notifications Available
                  </Typography>
                ) : (
                  notification_list?.map((notification, index) => (
                  <div
                    className={`p-3 mb-2 d-flex gap-3 align-items-start ${Number(notification.is_read) === 1
                      ? "notification-read"
                      : "notification-unread"
                      }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigateNotification(notification);
                      notificationCancel(notification.notification_id);
                    }}
                    key={index}
                  >
                    <Avatar alt="Profile" src={notification.image_url} />
                    <div>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#333",
                          fontSize: "1rem",
                          lineHeight: "1.4",
                        }}
                      >
                        {notification.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#333",
                          fontSize: "0.8rem",
                          lineHeight: "1.4",
                          textAlign: "justify",
                          // textIndent: 20,
                        }}
                      >
                        {notification.message}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#888",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        {notification.created_at
                          ? format(
                            new Date(notification.created_at),
                            "dd/MM/yyyy hh:mm a"
                          )
                          : "N/A"}
                      </Typography>
                    </div>
                  </div>
                ))
                )}
              </Drawer>
              
              <Drawer
                anchor="right"
                open={drawerTimer}
                onClose={() => setDrawerTimerOpen(false)}
                transitionDuration={{ enter: 300, exit: 300 }}
                sx={{
                  "& .MuiDrawer-paper": {
                    width: "350px",
                    padding: "16px",
                    backgroundColor: "var(--cell-bg-color)",
                  },
                }}
              >
                {login_user_role === "ADMIN" && (
                  <Tooltip title="Select Timer View" arrow>
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                      <Select
                        value={timerType}
                        onChange={(e) => setTimerType(e.target.value)}
                        displayEmpty
                        inputProps={{ "aria-label": "Timer Type" }}
                        sx={{
                          fontSize: "0.8rem",
                          backgroundColor: "var(--cell-bg-color)",
                          borderRadius: "8px",
                          height: "32px",
                        }}
                      >
                        <MenuItem value="myTimer">My Timer</MenuItem>
                        <MenuItem value="allTimers">All Timer</MenuItem>
                      </Select>
                    </FormControl>
                  </Tooltip>
                )}

                {/* Header with Close Button */}
                <div className="d-flex align-items-center justify-content-between">
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Timer Activities
                  </Typography>
                  <IconButton onClick={() => setDrawerTimerOpen(false)}>
                    <CloseIcon />
                  </IconButton>
                </div>
                {timerDetails.length === 0 && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#333",
                      fontSize: "0.8rem",
                      lineHeight: "1.4",
                      justifyContent: "center",
                      mx: "auto",
                      marginTop: "120px",
                    }}
                  >
                    No Active Timer Found
                  </Typography>
                )}

                {timerDetails?.map((notification, index) => (
                  <div
                    className={`p-3 mb-2 d-flex gap-3 align-items-start ${Number(notification.is_read) === 1
                      ? "notification-read"
                      : "notification-unread"
                      }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigateTimer(notification);
                    }}
                    key={index}
                  >
                    <Avatar alt="Profile" src={notification.user_image_url} />
                    <div>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#333",
                          fontSize: "0.9rem",
                          lineHeight: "1.4",
                        }}
                      >
                        {notification.project_title}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#333",
                          fontSize: "0.9rem",
                          lineHeight: "1.4",
                        }}
                      >
                        Title : {notification.title}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#333",
                          fontSize: "0.9rem",
                          lineHeight: "1.4",
                        }}
                      >
                        Status : {notification.status}
                      </Typography>

                      <Typography
                        variant="caption"
                        sx={{
                          color: "#888",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        {notification.created_at
                          ? format(
                            new Date(notification.created_at),
                            "dd/MM/yyyy hh:mm a"
                          )
                          : "N/A"}
                      </Typography>
                    </div>
                  </div>
                ))}
              </Drawer>

              <Tooltip title="Menu" arrow>
                <IconButton
                  color="inherit"
                  onClick={() => setShowMiniPopUp((prev) => !prev)}
                  sx={{
                    color: isDarkMode ? "#a0a0a0" : "#707070",
                    "&:hover": {
                      color: isDarkMode ? "#ffffff" : "#000000",
                      backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
                    }
                  }}
                >
                  <CgMenuGridO
                    style={{ fontSize: "1.8rem" }}
                  />
                </IconButton>

                {showMinipOPuP && (
                  <div
                    className="position-absolute bg-white shadow rounded p-3 z-100 floating-menu-inside-drawer right"
                    ref={popupRef}
                    style={{
                      top: "60px",
                      right: "20px",
                      width: "260px",
                      border: "1px solid #ddd",
                    }}
                  >
                    <div className="row text-center">
                      <div
                        style={{ cursor: "pointer" }}
                        className="col-4 mb-3"
                        onClick={() => CommonMenuShowPopup("deals")}
                      >
                        <Tooltip title="Deals">
                          <div className="commonCircle">
                            <MdAssignment color="rgb(15, 163, 141)" size={30} />
                          </div>
                        </Tooltip>
                        <div>Deals</div>
                      </div>

                      <div
                        className="col-4 mb-3"
                        onClick={() => CommonMenuShowPopup("HRMS")}
                        style={{ cursor: "pointer" }}
                      >
                        <Tooltip title="HRMS">
                          <div className="commonCircle">
                            {/* <img src={TaskImage} alt="HRMS" width={24} height={24} /> */}
                            <IoDocumentText color="rgb(15, 163, 141)" size={30} />
                          </div>
                        </Tooltip>
                        <div>HRMS</div>
                      </div>

                      <div
                        className="col-4 mb-3"
                        onClick={() => CommonMenuShowPopup("incentive")}
                        style={{ cursor: "pointer" }}
                      >
                        <Tooltip title="Incentive">
                          <div className="commonCircle">
                            {/* <img
                                                  src={IssueImage}
                                                  alt="Incentive"
                                                  width={24}
                                                  height={24}
                                                /> */}
                            <RiMoneyRupeeCircleLine
                              color="rgb(15, 163, 141)"
                              size={30}
                            />
                          </div>
                        </Tooltip>
                        <div>Incentive</div>
                      </div>

                      <div
                        className="col-4 mb-3"
                        onClick={() => CommonMenuShowPopup("assessment")}
                        style={{ cursor: "pointer" }}
                      >
                        <Tooltip title="Assessment">
                          <div className="commonCircle">
                            <MdAssessment color="rgb(15, 163, 141)" size={30} />
                          </div>
                        </Tooltip>
                        
                        <div>Assessment</div>
                      </div>
                      <div
                        className="col-4 mb-3"
                        onClick={() => CommonMenuShowPopup("CRM")}
                        style={{ cursor: "pointer" }}
                      >

                        <Tooltip title="CRM">
                          <div className="commonCircle">
                            <FaUserCog color="rgb(15, 163, 141)" size={30} />
                          </div>
                        </Tooltip>
                        <div>CRM</div>
                      </div>
                    </div>
                  </div>
                )}

                {/* <Avatar
                alt="Profile"
                src={user_icon}
                style={{ marginLeft: "8px" }}
              /> */}

              </Tooltip>
              <div>
                {/* Avatar Button */}
                <Tooltip title="Profile" arrow>
                  <Avatar
                    alt=""
                    src={user_list_info?.image_url}
                    style={{ marginLeft: "8px", cursor: "pointer" }}
                    onClick={handleAvatarClick}
                  />
                </Tooltip>

                {/* Popover for user details */}
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem>
                    <Typography variant="subtitle1">
                      Name : <strong>{user_list_info?.name || "User"}</strong>
                    </Typography>
                  </MenuItem>

                  <MenuItem>
                    <Typography variant="body2">
                      Email : {user_list_info?.email || "email@example.com"}
                    </Typography>
                  </MenuItem>

                  <MenuItem>
                    <Typography variant="body2">
                      Designation: {user_list_info?.designation}
                    </Typography>
                  </MenuItem>

                  <MenuItem onClick={() => navigate("/change-password")}>
                    <AiOutlineUser style={{ marginRight: "8px" }} />
                    <Typography variant="body2">Change password</Typography>
                  </MenuItem>
                  
                  <MenuItem onClick={handleClickOpen} style={{ color: "red" }}>
                    <AiOutlineLogout style={{ marginRight: "8px" }} />
                    Logout
                  </MenuItem>
                </Menu>

                {/* Logout Confirmation Dialog */}
                <Dialog
                  open={openDialog}
                  onClose={handleCloseDialog}
                  aria-labelledby="confirm-logout-title"
                  aria-describedby="confirm-logout-description"
                >
                  <DialogTitle id="confirm-logout-title">
                    Confirm Logout
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="confirm-logout-description">
                      Are you sure you want to logout?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDialog} color="secondary">
                      Cancel
                    </Button>
                    <Button onClick={handleLogout} color="primary" autoFocus>
                      Logout
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
